import { setSettingsCookie } from '@js/globalFunctions/cookieHandling'

import { resetSearch } from '@js/parts/search/functions/reset/resetSearch'

import { updateSelectedAreas } from '@js/parts/search/functions/areaSelector/updateSelectedAreas'
import { updateSelectedChangedays } from '@js/parts/search/functions/changeDays/updateSelectedChangedays'
import { updateSelectedDates } from '@js/parts/search/functions/dateSelector/updateSelectedDates'
import {updateTagsView} from "@js/parts/search/functions/searchfilterbox/updateTagsView";


export function resetAllSearchParts(withUrlUpdate)
{
	withUrlUpdate = (typeof withUrlUpdate === 'boolean') ? withUrlUpdate : true ;
	
	dataholder.selectedAreaHolder = [];
	dataholder.selectedChangedayHolder = [];
	
	if( $('#faneFeriehus').length !== 0 )
	{
		const area = $('#faneFeriehus').attr('data-slug');
		if( typeof area !== 'undefined' && area !== '' )
		{
			dataholder.selectedAreaHolder.push(area);
		}
	}
	dataholder.prevAreaHolder = false;
	dataholder.prevChangedayHolder = false;
	
	setSettingsCookie('noChangeDaySelected', false);
	setSettingsCookie('noAreaSelected', false);
	
	resetSearch();
	updateSelectedAreas( dataholder.selectedAreaHolder, true );
	updateSelectedDates( Array() );
	updateSelectedChangedays( dataholder.selectedChangedayHolder );
	updateTagsView();
	
	if(withUrlUpdate)
	{
		
		if (window.location.href.indexOf(siteSearchPage) !== -1)
		{
			if (window.location.href === siteSearchPage + '?result/#/page=/1')
			{
				location.reload();
			}
			else
			{
				window.location = siteSearchPage + '?result/#/page=/1';
			}
		}
		else
		{
			var url = location.protocol + '//' + location.host + location.pathname;
			
			if (siteTmpl === 'tmpl-faner-page' || siteTmpl === 'tmpl-aktiviteter')
			{
				url += "#" + wpTranslatedStrings.terms.vacationHouse;
			}
			
			if (window.location.href === url)
			{
				location.reload();
			}
			else
			{
				if (url.indexOf(location.host + location.pathname) !== -1)
				{
					window.location = url;
				}
				else
				{
					window.location = url;
				}
			}
		}
	}
}
